export default (state, action) => {
  const {
    payload: { code, content, msg }
  } = action;

  return {
    ...state,
    save: {
      ...state.save,
      content,
      error: code === 0 ? undefined : msg || "error",
      success: code === 0 ? msg || "success" : undefined
    }
  };
};
